export const styles = {
  agendaItemPublicCtn: {
    border: "1px solid #e6e6e6",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "row",
    marginBottom: "20px",
    overflow: "hidden",
    minHeight: "140px",
    width: "100%",
    boxSizing: "border-box",
  },
  agendaItemLeft: {
    padding: "25px",
    minWidth: "70px",
    maxWidth: "70px",
    display: "flex",
    flexDirection: "column",
  },
  startTime: {
    fontSize: "16px",
    lineHeight: "21px",
    color: "text.primary",
    fontWeight: 500,
  },
  endTime: {
    fontSize: "12px",
    lineHeight: "16px",
    color: "text.primary",
  },
  duration: {
    fontSize: "14px",
    lineHeight: "19px",
    color: "text.primary",
    marginTop: "33px",
    display: "flex",
    alignItems: "center",
    "& svg": {
      width: "17px",
      marginRight: "5px",
      opacity: 0.7,
    },
  },
  separator: {
    width: "2px",
    minWidth: "2px",
    maxWidth: "2px",
    margin: 0,
  },
  agendaItemRight: {
    padding: "25px",
    display: "flex",
    maxWidth: "405px",
    overflow: "hidden",
    flexDirection: "column",
    boxSizing: "border-box",
    flexGrow: 1,
  },
  itemText: (moreTextVisible?: boolean) => ({
    fontSize: "14px",
    lineHeight: "21px",
    color: "text.primary",
    marginTop: "15px",
    overflow: "hidden",
    ...(moreTextVisible
      ? {
          display: "block",
        }
      : {
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
        }),
  }),
  seeMoreContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  },
  seeMoreButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: 0,
    color: "var(--GreenRemo)",
    marginLeft: "auto",
    fontSize: "14px",
    lineHeight: "19px",
    marginTop: "10px",
    "&:focus": {
      outline: "none",
    },
  },
};
